module.exports = __webpack_public_path__ + "static/media/staff.5368c329.png";